import alertify from 'alertifyjs'
import 'alertifyjs/build/css/alertify.min.css'
import { l } from 'client/Other/Translation'

import './Notifier.scss'

interface InstantNotificationInterface {
  (translationKey: string, type: 'success' | 'warning' | 'error')
}

export const notifier: InstantNotificationInterface = (translationKey, type, wait = 5) => {
  alertify.set('notifier', 'position', 'top-right')
  alertify.notify(l(translationKey), type, wait)
}
